export default __webpack_public_path__ + "static/media/peace.d1492847.png";